import React, { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import confetti from "canvas-confetti";
import Thankimage from "../../Images/thankyoubanner.svg";

export default function Thankyou() {
  const navigate = useNavigate();
  const location = useLocation();

  // ✅ Get enrollment data from payment page
  const enrollmentData = location.state || {};
  
  const {
    enrollment_id,
    course_name,
    amount,
    duration,
    start_date,
    end_date,
    lectures,
    skill_level,
    language,
  } = enrollmentData;

  // ✅ Helper to format date
  const formatDate = (dateStr) => {
    if (!dateStr) return "N/A";
    const d = new Date(dateStr);
    const options = { day: "2-digit", month: "short", year: "numeric" };
    return d.toLocaleDateString("en-US", options);
  };

  // 🎉 Confetti animation
  useEffect(() => {
    confetti({
      particleCount: 120,
      spread: 70,
      origin: { y: 0.6 },
    });
  }, []);

  // ✅ Redirect if no enrollment data
  useEffect(() => {
    if (!enrollment_id) {
      setTimeout(() => navigate("/courses"), 2000);
    }
  }, [enrollment_id, navigate]);

  return (
    <div className="flex flex-col items-center justify-center bg-white min-h-screen pb-16">
      {/* Banner Image */}
      <div className="w-full">
        <img
          src={Thankimage}
          alt="Appointment Confirmation"
          className="
            w-full 
            h-auto 
            max-h-[300px] 
            object-contain 
            sm:object-cover 
            sm:max-h-[260px]
          "
        />
      </div>

      {/* Thank You Section */}
      <div className="w-full max-w-lg text-center mt-10 px-6 sm:px-4">
        {/* Checkmark */}
        <div className="flex justify-center items-center mb-4">
          <div className="rounded-full border-4 border-green-500 w-14 h-14 sm:w-16 sm:h-16 flex justify-center items-center shadow-md">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-7 w-7 sm:h-8 sm:w-8 text-green-500"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth={3}
            >
              <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
            </svg>
          </div>
        </div>

        {/* Title */}
        <h1 className="text-2xl sm:text-3xl font-bold text-gray-900">
          Thank You!
        </h1>

        {/* Message */}
        <p className="text-gray-600 mt-2 text-base sm:text-lg font-medium">
          Your Enrollment Is Confirmed Successfully.
        </p>

        {/* Course Name */}
        {course_name && (
          <p className="text-lg font-semibold text-teal-600 mt-3">
            {course_name}
          </p>
        )}

        {/* Details */}
        <div className="mt-6 text-gray-700 text-sm sm:text-base leading-relaxed bg-gray-50 p-5 rounded-lg shadow-sm space-y-3">
          <p>
            <strong>Enrollment ID:</strong> {enrollment_id || "N/A"}
          </p>
          <p>
            <strong>Course Duration:</strong> {formatDate(start_date)} – {formatDate(end_date)}
          </p>
          
        </div>

        {/* Button */}
        <button
          onClick={() => navigate("/myprograms")}
          className="
            mt-8 
            bg-teal-500 hover:bg-teal-600 
            text-white font-semibold 
            px-8 py-2.5 
            rounded-md shadow-md 
            transition-all duration-300
            text-sm sm:text-base
          "
        >
          Go to Program Page
        </button>
      </div>
    </div>
  );
}